#import "@/apollo/fragments/Campaign.gql"
#import "@/apollo/fragments/TemporaryUploadConfig.gql"

query Campaign($campaignId: ID!) {
    campaign(campaignId: $campaignId) {
        ...Campaign
        languages
        client {
            _id
            id
            logoUrl
            name
        }
        mastheadUploadConfig {
            ...Config
        }
        opendcPlatformSettings {
            campaignType
        }
    }
}
